'use client';

import { useEffect } from 'react';
import { captureSourceData } from '@/core/utils/source-tracker';

export function SourceTrackerBootstrap() {
  useEffect(() => {
    captureSourceData();
  }, []);

  return null;
}
